'use client'

import { CardPage, CardTeam } from '@/components/Project'
import { Lib } from '@/types'
import useEmblaCarousel from 'embla-carousel-react'
import { Variant } from '.'
import CarouselScrollbar from './CarouselScrollbar'
import SectionSliderFragment from './query'

interface ClientProps {
  data: Lib.FragmentOf<typeof SectionSliderFragment>
  variant: Variant
}

const Client = ({ data, variant }: ClientProps) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ dragFree: true })

  const items = variant === 'team' ? data.teamMembers : data.pages

  return (
    <>
      <div
        className="embla__viewport px-lg pt-vertical-small pb-vertical-main md:pt-vertical-main col-span-12 overflow-hidden"
        ref={emblaRef}
      >
        <div className="embla__container gap-lg tablet:auto-cols-auto flex cursor-grab">
          {data?.titleFirstSlide && (
            <div className="embla__slide max-w-[500px] min-w-0 flex-[0_0_90%] max-md:hidden md:flex-[0_0_40%]">
              <h2 className="h4">{data.titleFirstSlide}</h2>
            </div>
          )}
          {items.map((item, k) => (
            <div
              className={
                'embla__slide max-w-[500px] min-w-0 flex-[0_0_90%] md:flex-[0_0_40%]'
              }
              key={k}
            >
              {variant === 'team' ? (
                <CardTeam
                  // @ts-expect-error
                  data={item}
                />
              ) : (
                <CardPage
                  // @ts-expect-error
                  data={item}
                />
              )}
            </div>
          ))}
        </div>
      </div>
      {data.scrollbar && (
        <CarouselScrollbar
          emblaApi={emblaApi}
          scrollSnaps={emblaApi?.scrollSnapList()}
        />
      )}
    </>
  )
}

export default Client
